module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0077.jpg?v=fab566c9";